module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('organizations.list'),
      expression: "'organizations.list'"
    }]
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('searchbar', {
    attrs: {
      "value": _vm.query.search,
      "model": _vm.model
    },
    on: {
      "search": _vm.search
    }
  })], 1), _vm._v(" "), _c('collection', {
    attrs: {
      "data": _vm.items,
      "structure": _vm.collectionData,
      "model": "organization"
    },
    on: {
      "itemDelete": _vm.itemDelete
    }
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "page": _vm.page,
      "total-pages": _vm.total_pages
    },
    on: {
      "goToPage": _vm.goToPage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23e69e92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/organizations/Organizations.vue
// module id = 1841
// module chunks = 0